import { render, staticRenderFns } from "./order-pass.vue?vue&type=template&id=58ebd736&scoped=true&"
import script from "./order-pass.vue?vue&type=script&lang=js&"
export * from "./order-pass.vue?vue&type=script&lang=js&"
import style0 from "./order-pass.vue?vue&type=style&index=0&id=58ebd736&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ebd736",
  null
  
)

export default component.exports